<p>
	<mat-spinner></mat-spinner>
</p>

<p>{{text}}</p>
